import React, { useEffect, useState } from "react";
import styles from "../../styles/Components/layout/layout.module.sass";
import Header from "../Header";
import loader from "../../asset/Images/Pulse-1s-200px.svg";
import { Button } from "antd";
import { setLogout } from "../../redux/main/action/main";
import PoolData from "../../pages/Auth/AWSConfig/PoolData";
import { useDispatch, useSelector } from "react-redux";
import alert from "../alerts/Alert";
import Navbar from "./Navbar";
import TutorialButton from "./TutorialButton";
import GlobalErrorBubble from "../../shared/GlobalErrorBubble";
import { clearLocalStorage } from "../../utility/helper";
import Sidebar from "./Sidebar";

const DashboardLayout = ({
  children,
  insightLayout,
  loading,
  error,
  aiLayout,
  alertSystem,
  hasDemo,
}) => {
  const [errorPage, setErrorPage] = useState(false);
  const [toggle, setToggle] = useState(2);
  const dispatch = useDispatch();
  const {
    initialInfo: { CATEGORIES_FEATURE_TREE },
  } = useSelector((state) => state?.insightState);
  const items = [
    { label: "Menu", key: 1 },
    { label: "Features", key: 2 },
  ];
  const onChange = (key) => {
    setToggle(key);
  };

  const swal = (text) => {
    return alert(null, text, "warning", {
      cancel: "Close",
      defeat: {
        text: "Buy Plan",
        value: "buyPlan",
      },
    });
  };
  // let localToken = JSON.parse(
  //   localStorage.getItem("aws-amplify-federatedInfo")
  // )?.token;
  useEffect(() => {
    if (error?.response?.status == 401 || error?.status === 401) {
      dispatch(setLogout());
      const user = PoolData.getCurrentUser();
      user?.signOut();
      // localStorage.clear();
      clearLocalStorage();
      // window.location.reload(false);
      window.location.reload();
    }
    if (error?.response?.status == 504 || error?.status === 504) {
      setErrorPage(true);
    }
    if (Array.isArray(error?.RESPONSE_LIST)) {
      error?.RESPONSE_LIST?.map((item) => {
        switch (item?.STATUS_CODE) {
          case 401: {
            swal(
              "You have reached daily limit, for unlimited use, you should buy pro plan",
            );
            break;
          }
          // case 402: {
          //   swal("Your account is expired");
          //
          //   break;
          // }
          case 403: {
            swal("Insufficient credit");
            break;
          }
          case 410: {
            swal(
              "Check your connection! Your Internet does not seem to be stable",
            );
            break;
          }
          default: {
            return;
          }
        }
      });
    }
    if (error) {
      switch (error?.STATUS_CODE) {
        case "401": {
          swal(
            "You have reached daily limit, for unlimited use, you should buy pro plan",
          );
          break;
        }
        // case "402": {
        //   swal("Your account is expired");
        //
        //   break;
        // }
        case "403": {
          swal("Insufficient credit");
          break;
        }
        default: {
          return;
        }
      }
    }
  }, [error]);

  return (
    <>
      <div className={styles.container}>
        <Sidebar />
        {/*<SideBar insightLayout={insightLayout} />*/}
        <div
          className={styles.mainAndHeaderContainer}
          style={{
            width: `${JSON.parse(localStorage.getItem("sidebar-collapsed")) ? "100%" : "calc(100% - 230px)"}`,
          }}
        >
          <Header />
          <GlobalErrorBubble />
          <div className={insightLayout ? styles.insightMain : styles.main}>
            {errorPage ? (
              <div className={styles.errorWrapper}>
                <h3>Something went wrong please refresh the page</h3>
                <Button onClick={() => window.location.reload()}>
                  Refresh
                </Button>
              </div>
            ) : (
              children
            )}
          </div>
          <Navbar />
        </div>
        <div
          className={`${styles.loadingContainer} ${
            loading ? styles.showLoading : ""
          }`}
        >
          <img src={loader} alt="loader" />
        </div>
        {hasDemo && <TutorialButton />}
      </div>
    </>
  );
};

export default DashboardLayout;
